import { useNavigate } from "react-router-dom";
import { Wrench, Shield, MapPin, MessageCircle } from "lucide-react";

const actions = [
  { icon: Wrench, label: "Maintenance", description: "Track & log service", to: "/maintenance", color: "bg-primary/10 text-primary" },
  { icon: Shield, label: "Warranty", description: "Know your coverage", to: "/dealer-claims", color: "bg-success/10 text-success" },
  { icon: MapPin, label: "Find Service", description: "Nearby centers", to: "/service", color: "bg-warning/10 text-warning" },
  { icon: MessageCircle, label: "Ask My RV", description: "AI-powered help", to: "/ask-my-rv", color: "bg-info/10 text-info" },
];

export function QuickActionsGrid() {
  const navigate = useNavigate();

  return (
    <div className="px-4 mt-6">
      <h3 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider mb-3">
        Quick Actions
      </h3>
      <div className="grid grid-cols-2 gap-3">
        {actions.map(({ icon: Icon, label, description, to, color }) => (
          <button
            key={label}
            onClick={() => navigate(to)}
            className="flex flex-col items-start gap-2 p-4 rounded-xl bg-card border border-border/50 shadow-sm hover:shadow-md active:scale-[0.98] transition-all duration-200 text-left"
          >
            <div className={`p-2 rounded-lg ${color}`}>
              <Icon className="h-5 w-5" />
            </div>
            <div>
              <p className="text-sm font-semibold text-foreground">{label}</p>
              <p className="text-xs text-muted-foreground">{description}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
